/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
/** @packageDocumentation
 * @module StatusBar
 */

import { StatusBarItemsManager as UIA_StatusBarItemsManager } from "@bentley/ui-abstract";

/** StatusBar Items Manager class.
 * @beta @deprecated Use StatusBarItemsManager in bentley/ui-abstract instead
 */
export class StatusBarItemsManager extends UIA_StatusBarItemsManager { }
